// extracted by mini-css-extract-plugin
export default {"container":"AuthPage_container__Jiew2"};